import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { Avatar } from '@mui/material';

import { gradient } from './assistant-theme';

interface AssistantAvatarProps {
  size?: number;
  iconSize?: number;
}

export default function AssistantAvatar({
  size = 26,
  iconSize = 15,
}: AssistantAvatarProps) {
  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        background: gradient,
        color: '#fff',
      }}
    >
      <AutoAwesomeIcon sx={{ fontSize: iconSize }} />
    </Avatar>
  );
}
